import React from "react";
import { contentTipology } from "../../app/models/node";

interface IParams {
  nodeKey?: string;
  hasDocument?: boolean;
  isFolder?: boolean;
  hasChildren?: boolean;
  type?: contentTipology;
  expandedByDefault?: boolean;
  }

const ArchiveTreeIcon: React.FC<IParams> = ({ nodeKey, hasDocument, hasChildren, type, expandedByDefault}) => {
  
  const getIconByType = (type?: contentTipology) => {
    if(type === undefined) return null;
    switch (type) {
      //none
      case 0:
        // <i class="fas fa-question"></i>
      return <i className="fad fa-file-exclamation"></i>;
      //image
      case 1:
      return <i className="fas fa-file-image"></i>;
      //pdf
      case 2:
      return <i className="fas fa-file-pdf"></i>;
      //powerPoint
      case 3:
      return <i className="fas fa-file-powerpoint"></i>;
      //video
      case 4:
      return <i className="fas fa-file-video"></i>;
      //doc
      case 5:
      return <i className="fas fa-file-word"></i>;
      //www
      case 6:
      return <i className="fas fa-external-link-alt"></i>;
      //audio
      case 7:
      return <i className="fas fa-file-music"></i>;
      //excelly
      case 8:
      return <i className="fas fa-file-excel"></i>;
      default:
        return <i className="fas fa-question"></i>;
    }
  }
return (
    // ICONE FONTAWESOME
    <div className="w-100 h-100">
      {hasDocument!== undefined && (
    <div className="odgIcon">{
         hasDocument ? (
          <i id={`containerIcon${nodeKey}`} className={(expandedByDefault ? "fas fa-folder-open" : "fas fa-folder") + " cursorPointer"} style={{color: "#000000"}}></i>
        )
        : (hasChildren !== undefined ? (
            hasChildren ? 
              <i className="fas fa-archive text-dark cursorPointer"></i>
              :
              <i className="fas fa-archive text-light cursorNone"></i>
            ) : (
              getIconByType(type)
            )
        )}
    </div>
    )}
  </div>
  );
};

export default ArchiveTreeIcon;
